<template>
  <div>
    <div>
      <a-row>
        <a-col :span="4">
          <a-input placeholder="学生名" v-model="queryParam.realname"></a-input>
        </a-col>
        <a-col :span="4">
          <a-input
            placeholder="学生账号"
            v-model="queryParam.username"
          ></a-input>
        </a-col>
        <a-col :span="4">
          <j-select-depart :onlyCategory="3" :onlyMyDepart="true" v-model="queryParam.departId" :multi="true"></j-select-depart>
        </a-col>
        <a-col :span="1"></a-col>
        <a-col :span="4">
          <a-button type="primary" @click="search">查询</a-button>
        </a-col>
        <a-col :span="1"></a-col>
        <a-col :span="5">
          <!-- <a-button type="primary" @click="handleExportXls">导出学生</a-button> -->
          <!-- <a-divider type="vertical"></a-divider> -->
          <a-button type="primary" @click="handleImportStudent"
            >导入学生</a-button
          >
          <a-divider type="vertical"></a-divider>
          <a-button type="primary" @click="handleAdd">添加学生</a-button>
        </a-col>
      </a-row>
    </div>
    <a-divider></a-divider>
    <div>
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(text)" icon="user" />
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)" v-has="'user:edit'">编辑</a>-->
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a href="javascript:;" @click="handleChangePassword(record.username)"
            >密码</a
          >
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status == 1">
                <a-popconfirm
                  title="确定冻结吗?"
                  @confirm="() => handleFrozen(record.id, 2, record.username)"
                >
                  <a>冻结</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status == 2">
                <a-popconfirm
                  title="确定解冻吗?"
                  @confirm="() => handleFrozen(record.id, 1, record.username)"
                >
                  <a>解冻</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <password-modal ref="passwordmodal"></password-modal>
    <student-modal ref="modalForm" @ok="search()"></student-modal>
    <import-student-modal ref="importStudentModal" />
  </div>
</template>

<script>
import { downFile } from "@/api/manage";
import { getMineStudent, forzenUser, deleteUser } from "@/api/user";
import PasswordModal from "@/components/common/PasswordModal";
import StudentModal from "@/components/common/StudentModal";
import ImportStudentModal from "@/components/common/ImportStudentModal";
import JSelectDepart from '@/components/jeecg/JSelectDepart'
import { JeecgListMixin } from "@/utils/JeecgListMixin";
export default {
  name: "TeacherStudent",
  mixins: [JeecgListMixin],
  components: {
    PasswordModal,
    StudentModal,
    ImportStudentModal,
    JSelectDepart
  },
  data() {
    return {
      columns: [
        // {
        //   title: '用户ID',
        //   align: 'center',
        //   dataIndex: 'id',
        // },
        {
          title: "账号",
          align: "center",
          dataIndex: "username",
          width: 120,
          sorter: true,
        },
        {
          title: "姓名",
          align: "center",
          width: 100,
          dataIndex: "realname",
        },
        // {
        //   title: '头像',
        //   align: 'center',
        //   width: 120,
        //   dataIndex: 'headimgurl',
        //   scopedSlots: { customRender: 'avatarslot' },
        // },
        // {
        //   title: '微信昵称',
        //   align: 'center',
        //   width: 100,
        //   dataIndex: 'nickname',
        // },
        {
          title: "性别",
          align: "center",
          width: 80,
          dataIndex: "sex_dictText",
          sorter: true,
        },
        {
          title: "生日",
          align: "center",
          width: 100,
          dataIndex: "birthday",
        },
        {
          title: "手机号码",
          align: "center",
          width: 100,
          dataIndex: "phone",
        },
        // {
        //   title: '积分',
        //   width: 50,
        //   dataIndex: 'integral',
        // },
        {
          title: "班级",
          align: "center",
          width: 180,
          dataIndex: "orgCodeTxt",
        },
        {
          title: "状态",
          align: "center",
          width: 80,
          dataIndex: "status_dictText",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: 170,
        },
      ],
      url: {
        list: "/sys/user/list",
        delete: "/teaching/teachingAdditionalWork/delete",
        deleteBatch: "/teaching/teachingAdditionalWork/deleteBatch",
      },
    };
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      this.loading = true;
      if(this.queryParam.realname){
        this.queryParam.realname = "*" + this.queryParam.realname + "*"
      }
      this.loadData(1);
      // getMineStudent(this.queryParam).then((res) => {
      //   this.dataSource = res.result.records;
      //   this.ipagination.total = res.result.total;
      //   if(this.queryParam.realname){
      //     this.queryParam.realname = this.queryParam.realname.replaceAll("*","")
      //   }
      //   this.loading = false;
      // });
    },

    handleDelete: function (id) {
      var that = this;
      deleteUser(id).then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          that.search();
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    handleFrozen: function (id, status) {
      let that = this;
      forzenUser({ ids: id, status: status }).then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          that.search();
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "编辑";
      this.$refs.modalForm.disableSubmit = false;
    },
    handleAdd: function () {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = "新增";
      this.$refs.modalForm.disableSubmit = false;
    },
    handleChangePassword(username) {
      this.$refs.passwordmodal.show(username);
    },
    handleImportStudent() {
      this.$refs.importStudentModal.show();
    },
    handleExportXls() {
      let param = { ...this.queryParam };
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param["selections"] = this.selectedRowKeys.join(",");
      }
      console.log("导出参数", param);
      downFile("/sys/user/exportXls", param).then((data) => {
        if (!data) {
          this.$message.warning("文件下载失败");
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(
            new Blob([data], { type: "application/vnd.ms-excel" }),
            "学生导出.xls"
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: "application/vnd.ms-excel" })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "学生导出.xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
  },
};
</script>

<style>
</style>